export default __webpack_public_path__ + "static/media/img8.c82618a5.png";